/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_Copy_HtmlInputs */

const en_directory_submit_badge_copy_html = /** @type {(inputs: Directory_Submit_Badge_Copy_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy HTML`)
};

const zh_directory_submit_badge_copy_html = /** @type {(inputs: Directory_Submit_Badge_Copy_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制 HTML`)
};

/**
* | output |
* | --- |
* | "Copy HTML" |
*
* @param {Directory_Submit_Badge_Copy_HtmlInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_copy_html = /** @type {((inputs?: Directory_Submit_Badge_Copy_HtmlInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_Copy_HtmlInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_copy_html(inputs)
	return zh_directory_submit_badge_copy_html(inputs)
});
export { directory_submit_badge_copy_html as "directory.submit.badge_copy_html" }